import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {DisplaySmallTypography} from 'patient-ping-remedy/packages/typography';

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr min(33%, 54rem);
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding-top: 3rem;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: ${colors.white};
  border-top: 1px solid ${colors.gray2};
`;

export const Messages = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};
  min-height: 0;
  overflow-y: auto;
  background: ${colors.white};
  border-left: 1px solid ${colors.gray2};
  padding: ${sizes.medium};
`;

export const MessagesTitle = styled(DisplaySmallTypography)`
  padding-bottom: ${sizes.xSmall};
  border-bottom: 1px solid ${colors.gray2};
  font-weight: bold;
`;
